/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type SoftwareDeploymentsEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const softwareDeploymentsEntrypoint: EntryPoint<SoftwareDeploymentsEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<SoftwareDeploymentsEntrypointComponent>(
			/* webpackChunkName: "async-deployments-entrypoint" */ './DeploymentsPage.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
